import { useContext } from 'react'
import { useSelector } from 'react-redux'
import { ModalContext, ModalKey } from 'components/Modals/ModalContext'
import kinesisLogo from 'media/kinesis_logo.png'

import GroupCompletionLinearFill from 'components/Athlete/v2/AthleteCalendar/AthleteCalendarEventItems/GroupCompletionLinearFill'

export default function FutureKinesisWorkoutCalendarEventItem({ eventData }) {

    const { ShowModal } = useContext(ModalContext)

    const profileType = useSelector((state) => state.athleteProfile.profileType)

    const ShowWorkoutOverrideModal = () => {
        const modalData = {
            key: ModalKey.WorkoutOverride,
            size: 'third',
            calendarDataKey: eventData.extendedProps.calendarDataKey,
            weekOfTheYearKey: eventData.extendedProps.weekOfTheYearKey,
            workoutTemplateKey: eventData.extendedProps.workoutTemplateKey,
            showStartWorkoutButton: false
        }

        ShowModal(modalData)
    }

    if (profileType === 'group') {
        return (
            <div 
                onClick={ShowWorkoutOverrideModal}
            >
                <div className='flex items-center gap-x-0.5'>
                    <img src={kinesisLogo} alt='Kinesis Logo' className='h-4 w-4' />
                    <div className='text-gray-800 text-xxs 2xl:text-xs font-medium whitespace-normal'>{eventData.title}</div>
                </div>

                <GroupCompletionLinearFill calendarDataKey={'future'} eventData={eventData} />
            </div>
        )
    }

    if (profileType === 'group-individual' || profileType === 'individual') {
        return (
            <div 
                onClick={ShowWorkoutOverrideModal}
            >
                <div className='flex items-center gap-x-0.5'>
                    <img src={kinesisLogo} alt='Kinesis Logo' className='h-4 w-4' />
                    <div className='text-gray-800 text-xxs 2xl:text-xs font-medium whitespace-normal'>{eventData.title}</div>
                </div>

                <div className='pl-0.5 text-gray-500 text-xxs 2xl:text-xs'>Preview</div>
            </div>
        )
    }
}